import { ISignDocMainInfoProps } from "../../../../../../interfaces/props/RequiringSigningDocs/IRequiringSigningDocs";
import { formatPrice } from "../../../../../../utils/utilities/formatPrice";
import classes from "./SignDocApplicationInfo.module.css";
import React from "react";

export const SignDocApplicationInfo = ({
  applicationNumber,
  sumBg,
  tenderNumber,
}: ISignDocMainInfoProps) => {
  return (
    <div className={classes.docMainInfo}>
      <p className={classes.applicationNumber}>Заявка № {applicationNumber}</p>

      <div className={classes.applicationInfo}>
        <span className={classes.tenderNumber}>Тендер № {tenderNumber}</span>
        <span>Сумма БГ {formatPrice(sumBg)}</span>
      </div>
    </div>
  );
};
